export enum FcOrder {
    isOrderByKiosk = 2,
}